
angular.module('admin.cover.index', [
    'security.authorization',
    'services.utility',
    'services.adminResource',
    'services.search',
    'services.formErrors',
    'resources.User',
]);

angular.module('admin.cover.index').config(["$stateProvider", function ($stateProvider) {

    $stateProvider
        .state('admin.cover', {
            url: '/cover',
            title: 'Admin / Cover',
            views: {
                'main@': {
                    template: require('./cover.tpl.html'),
                    controller: 'AdminCoverCtrl',
                    resolve: {
                        // pre-load resources
                    }
                }
            }
        });
}]);

angular.module('admin.cover.index').controller('AdminCoverCtrl',
    ["$scope", "$state", "formErrors", "$location", "user", "growl", "Upload", "$sce", "APP_IMG_URLS", function ($scope, $state, formErrors, $location, user, growl, Upload, $sce, APP_IMG_URLS) {
        $scope.uploading = false;
        $scope.imgUrl = APP_IMG_URLS.base;
        $scope.coverImg = 'diario.jpg?r=' + Math.random();
        $scope.coverPdf = $sce.trustAsResourceUrl(APP_IMG_URLS.base + 'diario.pdf?r=' + Math.random());

        $scope.$watch('file', function (file) {
            if (!file) return;
            $scope.upload(file);
        });

        // upload on Image Cover file select or drop
        $scope.upload = function (file) {
            console.log(file.size );
            $scope.uploading = true;
            $scope.coverImg = null;
            Upload.upload({
                url: '/api/articles/upload?type=cover-image',
                data: {
                    file: file
                }
            }).then(function (resp) {
                $scope.uploading = false;
                $scope.coverImg = 'diario.jpg?r=' + Math.random();
            }, function (resp) {
                $scope.uploading = false;
                $scope.coverImg = 'diario.jpg?r=' + Math.random();
                console.log('Error status: ' + resp.status);
            }, function (evt) {
                var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
            });
        };


        $scope.$watch('file1', function (file) {
            if (!file) return;
            $scope.upload1(file);
        });

        // upload on PDF file select or drop
        $scope.upload1 = function (file) {
            $scope.uploading = true;
            Upload.upload({
                url: '/api/articles/upload?type=cover-pdf',
                data: {
                    file: file
                }
            }).then(function () {
                $scope.uploading = false;
                $scope.coverPdf = $sce.trustAsResourceUrl(APP_IMG_URLS.base + 'diario.pdf?r=' + Math.random());
            }, function (resp) {
                $scope.uploading = false;
                $scope.coverPdf = $sce.trustAsResourceUrl(APP_IMG_URLS.base + 'diario.pdf?r=' + Math.random());
                console.log('Error status: ' + resp.status);
            }, function (evt) {
                var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
            });
        };
    }]);



// WEBPACK FOOTER //
// ./client/src/app/admin/cover/cover.js